'use strict';

import baseConfig from './base';

let config = {
  appEnv: 'dist',
  api: '/api',
  testBaseUrl: '/tests/',
  requestTimeout: 30000
};

export default Object.freeze(Object.assign({}, baseConfig, config));
